module.exports = __webpack_public_path__ + "img/ico24.6b2952e7.jpg";